import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function SearchIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12Zm7.5 1.5-3.25-3.25"
  }));
}

export { SearchIcon };
//# sourceMappingURL=Search.mjs.map
